var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.0bf629514b3723d0692365a25d7a932d.svg#Q';
                    var viewUrl = 'sprites.0bf629514b3723d0692365a25d7a932d.svg#view-Q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };